import { FileText } from "lucide-react";
import { useTracker } from "@ferrivia/auth-web";
import { useFormatters, useTranslation } from "@ferrivia/i18n";
import type { SummaryReadyBlock as SummaryReadyBlockData } from "@ferrivia/api-contract";
import { useAppContext } from "../../../../app/useAppContext";
import { Notification } from "../../../../components/Notification";

export function SummaryReadyBlock({ id, summaryId, submittedAt }: SummaryReadyBlockData) {
  const { t } = useTranslation("client");
  const { date } = useFormatters();
  const { openSummary } = useAppContext();
  const tracker = useTracker();

  const handleClick = () => {
    tracker.track("home.block_cta_clicked", { block_id: id });
    openSummary(summaryId, { source: "home" });
  };

  return (
    <Notification
      icon={FileText}
      title={t("home.blocks.summaryReady.title", "Henkilökohtainen rautaraporttisi on valmis")}
      detail={t("home.blocks.summaryReady.detail", "Lähetetty {{date}}", { date: date.format(new Date(submittedAt)) })}
      onClick={handleClick}
    />
  );
}
